import React from 'react';
import { PreviewComponent } from './PreviewFruit';

const PreviewCheese = props => (
    <div className="PreviewFruit">
        <div className={'CenterFruit o' + props.orientation}>
            <div className="PreviewFruitContainer">
                <PreviewComponent rayon="cheese" {...props} />
            </div>
        </div>
    </div>
);

export default PreviewCheese;
